import { render, staticRenderFns } from "./Takeout.vue?vue&type=template&id=57eac220"
import script from "./Takeout.vue?vue&type=script&lang=js"
export * from "./Takeout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports